import React from 'react'
import { KibTooltip, type KibTooltipProps } from '@chewy/kib-tooltip-react'

import type { PopperAction } from './ActionsPopper'
import RhapActionsPopperPortaled from './RhapActionsPopperPortaled'
import { renderRhapActionsMenuItem } from './rhapActionsPopperUtils'

import '@chewy/kib-tooltip-styles/dist/kib-tooltip.css'
import styles from './RhapActionsPopper.module.scss'

export interface RhapActionsPopperProps extends KibTooltipProps {
  actions?: PopperAction[]
  title?: string
  trigger?: React.RefObject<HTMLElement>
  usePortal?: boolean
}

const RhapActionsPopper = ({
  actions = [],
  title,
  usePortal = false,
  trigger,
  ...rest
}: RhapActionsPopperProps) => {
  const { placement = 'bottom', popperModifiers = [] } = rest

  if (usePortal && trigger) {
    return (
      <RhapActionsPopperPortaled
        actions={actions}
        placement={placement}
        popperModifiers={popperModifiers}
        title={title}
        trigger={trigger as React.RefObject<HTMLElement>}
      />
    )
  }

  return (
    <KibTooltip className={styles.tooltip} {...rest} trigger={trigger}>
      <div className={styles.actionsContainer}>
        {title && <div className={styles.title}>{title}</div>}
        {actions.filter(Boolean).map((item: PopperAction) => (
          <div key={item.id}>{renderRhapActionsMenuItem(item)}</div>
        ))}
      </div>
    </KibTooltip>
  )
}

export default RhapActionsPopper
